module.exports = __webpack_public_path__ + "static/media/SuccessSaveVendor.796a22b1.svg";